export default "__VITE_ASSET__Dvs9liD___"